import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/ppcp";

const ConfigContext = createContext({ upgrade_url: null, wp_mode: null });

/** Runtime config from the backend. No user-facing URL is ever hardcoded in the app. */
export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({ upgrade_url: null, wp_mode: null });

  useEffect(() => {
    api.get("/config").then((res) => setConfig(res.data)).catch(() => {});
  }, []);

  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};

export const useConfig = () => useContext(ConfigContext);
